<template>
  <div class="commentItem">
    <div class="items">
      <div class="item-header">
        <div class="avatar">
          <img class="img" :src="item.avatar" />
          <div class="info">
            <p class="name">
              {{ item.username }}
              <span
                :class="{
                  'user-type': true,
                  'user-type-admin': item.user_type === 4,
                }"
              >
                {{ item.user_type | enum("UserType") }}
              </span>
            </p>
          </div>
          <div class="hasReply" v-if="item.reply">
            <p class="reply-txt">回复</p>
            <div class="info">
              <p class="name">
                {{ item.reply.username }}
                <span
                  :class="{
                    'user-type': true,
                    'user-type-admin': item.reply.user_type === 4,
                  }"
                >
                  {{ item.reply.user_type | enum("UserType") }}
                </span>
              </p>
            </div>
          </div>
        </div>
        <p class="create-time">{{ item.created_at | tsFormatLong }}</p>
      </div>
      <div class="item-content">
        <p class="content" v-html="item.content"></p>
        <p
          class="replay"
          @click="reply(item)"
          v-if="$store.state.user_info.id != item.user_id && can_reply_comment"
        >
          回复
        </p>
        <p
          class="replay"
          @click="handleDeleteComment(item.id)"
          v-if="$store.state.user_info.id == item.user_id"
        >
          删除
        </p>
      </div>
    </div>
    <ReplayInput
      :placeholder="'回复' + replyname"
      v-if="item.showCommentInput"
      @publishComment="publishComment"
      ref="replayInput"
    />
  </div>
</template>
<script>
import ReplayInput from "./ReplayInput";
export default {
  components: { ReplayInput },
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    post_id: {
      type: Number,
      default: 0,
    },
    can_reply_comment: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      comment: "",
      replyname: "",
    };
  },
  methods: {
    reply(item) {
      item.showCommentInput = true;
      this.replyname = item.username;
      this.$emit("reply", item.id);
    },
    publishComment(content) {
      this.$emit("publishComment", content);
      this.$refs.replayInput.comment = "";
    },
    handleDeleteComment(id) {
      this.$emit("handleDeleteComment", id);
    },
  },
};
</script>
<style lang="scss" scoped>
.commentItem {
  .items {
    padding: 20px 0;
    border-bottom: 1px solid #e6e6e6;
    .item-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .avatar {
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        .img {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          margin-right: 12px;
        }
        .info {
          display: inline-block;
          max-width: 100%;
          border-radius: 30px;
          box-sizing: border-box;
          .name {
            height: 21px;
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(32, 36, 42, 1);
            line-height: 21px;
            .user-type {
              color: $primary-color;
              border: 1px solid $primary-color;
              font-size: 12px;
              padding: 0 2px;
              border-radius: 3px;
            }
            .user-type-admin {
              background-color: #666564;
              color: #ead2ab;
              border: 0;
            }
          }
        }
        .hasReply {
          display: flex;
          align-items: center;
          .reply-txt {
            margin: 0 8px;
          }
        }
      }
      .create-time {
        font-size: 13px;
        color: #666;
      }
    }
    .item-content {
      color: #666;
      margin-top: 10px;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      padding-left: 40px;
      .content {
        flex: 1;
        padding-right: 10px;
      }
      .replay {
        cursor: pointer;
        &:hover {
          color: $primary-color;
        }
      }
    }
  }
}
</style>
